import { Linking, TouchableOpacity, View } from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalise";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import FavComp from "components/FavComp";
import Heading from "components/Heading";
import ImageView from "../../image";
import { Link } from "expo-router";
import SaleComponent from "./SaleComponent";
import VText from "components/VText";
import { getFormatedCurrency } from "utils/common";
import { trackV2 } from "utils/Segment";
import { useSelector } from "react-redux";

const ProductCard = ({
  product,
  isFavorites = false,
  deleteFav = () => {},
  containerStyle = {},
  imageStyle = {},
  gender,
  title = "",
  current_filters = {},
  current_sort_order = "",
  current_page = 1,
  index = 0,
  isStoryProduct = false,
  id = "",
  storyId = "",
  story_title = "",
  product_position = 0,
}) => {
  const { filter_value, filter_type } = current_filters;
  const countrySymbol = useSelector(
    (state) => state.StoredutilsSlice.countrySymbol
  );
  return (
    <>
      <Link
        href={`${gender == "men" ? "/men" : ""}/product/${
          product?.productId || product?.id
        }/${product?.brandName}/${product?.productName}`?.replaceAll(" ", "-")}
        onPress={() => {
          if (isStoryProduct) {
            const eventData = {
              story_id: storyId,
              story_title: story_title,
              product_id: product?.productId || product?.id,
              product_name: product?.productName,
              product_position: product_position,
            };

            trackV2(ANALYTICS_EVENT_NAMES.STORY_PRODUCT_CLICKED, eventData);
          }

          if (isFavorites) {
            const eventData = {
              product_id: product?.productId || product?.id,
              product_name: product?.productName,
            };
            trackV2(ANALYTICS_EVENT_NAMES.FAVORITE_PRODUCT_CLICKED, eventData);
          }
          const eventData = {
            plp_title: title,
            product_id: product?.productId || product?.id,
            product_name: product?.productName,
            product_price: product?.productPrice,
            current_filters: filter_value,
            current_sort_order: current_sort_order,
            current_page: current_page,
            product_position: index + 1,
          };
          if (!isStoryProduct) {
            trackV2(ANALYTICS_EVENT_NAMES.PRODUCT_CLICKED, eventData);
          }
        }}
        style={[
          {
            width: isFavorites ? wp(190) : wp(260),
          },
          containerStyle,
        ]}
      >
        <View style={{}}>
          <View
            onPress={() => {}}
            activeOpacity={0.7}
            style={{
              width: "100%",
              alignSelf: "center",
            }}
          >
            <ImageView
              alt={product?.productName}
              source={{
                uri: product?.imageUrls[0],
                priority: ImageView.priority.high,
              }}
              resizeMode={ImageView.resizeMode.contain}
              style={[
                {
                  height: isFavorites ? hp(253.33) : hp(347),
                  width: isFavorites ? wp(190) : wp(260),
                  alignSelf: "center",
                },
                imageStyle,
              ]}
            />
            {product?.isPreorder && (
              <View
                style={{
                  paddingHorizontal: spH(8),
                  paddingVertical: 6,
                  borderWidth: 1,
                  borderColor: "#21242799",
                  borderRadius: 2,
                  alignSelf: "flex-end",
                  position: "absolute",
                  top: hp(320 - 40),
                  right: 8,
                  backgroundColor: "#FFFFFF",
                }}
              >
                <VText
                  style={{
                    lineHeight: fp(8),
                    fontSize: fp(8),
                    fontWeight: "550",
                    letterSpacing: "3%",
                    color: "#21242799",
                  }}
                >
                  PRE ORDER
                </VText>
              </View>
            )}
          </View>
          <View
            style={{
              paddingVertical: spV(16),
            }}
          >
            <View style={{}}>
              <Heading
                type="h5"
                numberOfLines={1}
                style={{
                  fontSize: fp(14),
                  fontWeight: "550",
                  lineHeight: "140%",
                  paddingBottom: spV(4),
                }}
                text={product?.brandName?.toUpperCase()}
              />
              <Heading
                type="h6"
                numberOfLines={1}
                style={{
                  fontSize: fp(14),
                  fontWeight: "350",
                  lineHeight: "140%",
                  paddingBottom: spV(4),
                  color: "#656565",
                  height: hp(15),
                }}
              >
                {product?.productName}
              </Heading>
              {product?.salePercentage && product?.salePercentage > 0 ? (
                <SaleComponent
                  originalPrice={product?.originalProductPrice}
                  finalPrice={product?.productPrice}
                  discountPercentage={product?.salePercentage}
                  discountStyle={{
                    fontSize: fp(14),
                    fontWeight: "550",
                    lineHeight: "140%",
                  }}
                  finalPriceStyle={{
                    fontSize: fp(14),
                    fontWeight: "550",
                    lineHeight: "140%",
                  }}
                  originalPriceStyle={{
                    fontSize: fp(14),
                    fontWeight: "550",
                    lineHeight: "140%",
                  }}
                />
              ) : (
                <VText
                  text={`${countrySymbol}${getFormatedCurrency(
                    product?.productPrice
                  )}`}
                  style={{
                    fontSize: fp(14),
                    fontWeight: "550",
                    lineHeight: "140%",
                  }}
                />
              )}
            </View>
          </View>
        </View>
      </Link>
      {isFavorites && (
        <FavComp deleteFav={deleteFav} productId={product?._id} />
      )}
    </>
  );
};

export default ProductCard;
